module.exports = __webpack_public_path__ + "static/media/heroVideoUpdated.466e8ee0.webm";